const Swal = require('sweetalert2');

class SweetAlertClass {

    config() {
        return {
            confirm: {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            },
            success: {
                title: 'Success!',
                text: "",
                icon: 'success',
                timer: 5000,
            },
            error: {
                title: 'Error!',
                text: "Something goes wrong!",
                icon: 'error',
                timer: 5000,
            },
        };
    }

    confirm(config = {}) {
        const options = {...this.config().confirm, ...config};
        return Swal.fire(options);
    }

    success(config = {}) {
        const options = {...this.config().success, ...config};
        return Swal.fire(options);
    }

    error(config = {}) {
        const options = {...this.config().error, ...config};
        return Swal.fire(options);
    }
}

const SweetAlert = new SweetAlertClass();

export default SweetAlert;

